import * as React from 'react';

import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';

import {Theme} from '@mui/styles';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize:"1rem"
  },
  instructions: {
    padding:15
  },
  formArea: {
    padding: 15
  }, 
  formField: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  style: any;
  onStyleChange: (style:any) => void;
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  style: any;
};

class StyleEditView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      style: this.props.style 
    };
  }

  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>, oldProps: Props & WithStyles<keyof typeof styles>) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also 
    this.setState({style:newProps.style})
  }

  render() {
    const {classes}: {classes: any} = this.props;

    return (
      <div className={classes.container}>
        Edit Style here
      </div>
    );

  }
}

export default withStyles(styles)(StyleEditView);


